import { render, staticRenderFns } from "./PermissionAssignmentRole.vue?vue&type=template&id=048dbca1&scoped=true&"
import script from "./PermissionAssignmentRole.vue?vue&type=script&lang=js&"
export * from "./PermissionAssignmentRole.vue?vue&type=script&lang=js&"
import style0 from "./PermissionAssignmentRole.vue?vue&type=style&index=0&id=048dbca1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048dbca1",
  null
  
)

export default component.exports